// extracted by mini-css-extract-plugin
export var textInput = "_ke-0";